// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been se fixt in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import "@/bootstrap/plugins";
import "@/bootstrap/raven";
import "@/bootstrap/axios-interceptor";
import "@/bootstrap/mixins";
import "@/bootstrap/filters";
import "@/bootstrap/validators";
import "@/bootstrap/css";

import i18n from "@/services/i18n";

Vue.config.productionTip = false;

import store from "@/store/index";
import router from "@/router";

/* eslint-disable no-new */
new Vue({
  el: "#app",
  i18n,
  router,
  store,
  components: { App },
  template: "<App/>",
});



// WEBPACK FOOTER //
// ./src/main.js